'use strict';

import {fnToastrFormError, printResponse, resetForm} from "../jquery-functions-library";
import {element_exists} from "../functions";
import { type } from "jquery";

export const fnPaySlipApproval = (tableName) => {

    var modal = $('#modal-reject-pay-slip');

    if (!element_exists(modal)) return false;

    var form = $('#form-reject-pay-slip');
    var btnApprove = '.btn-approve-pay-slip';
    var btnReject = '.btn-reject-pay-slip';

    modal.off().on('hidden.bs.modal', function () {
        resetForm(form);
        $(tableName).DataTable().ajax.reload(null, false);
    });

    $(document).off('click', btnApprove);
    $(document).on('click', btnApprove, function (e) {
        var rowData = JSON.parse($(tableName).DataTable().row($(this).parents('tr')).data().payslip);

        e.preventDefault();
        var lang = allLangFiles.salary.pay_slips.js.approve;
        var langTwoStep = allLangFiles.salary.pay_slips.two_step_approval;
        
        //check if $(this).data("first-approval") exists
        if($(this).data("first-approval")){
            var approvedByFirstApprover = $(this).data("first-approval").trim();
        };

        var approver = $(this).data("approver");
        var approverUserName = $(this).data("user-name");
        rowData.approverUserName = approverUserName;

        if (approvedByFirstApprover == 'true' || approver == 'first-approver' || approver == 'no-two-step-approval-flow') {
        $.confirm({
            title: lang.title,
            content: lang.content,
            theme: 'supervan',
            columnClass: 'col-md-12',
            backgroundDismiss: true,
            buttons: {
                Ja: {
                    action: function () {

                        e.preventDefault();

                        $.ajax({
                            type: 'POST',
                            data: rowData,
                            url: '/salary/pay-slips/approve',
                            success: function (response) {
                                printResponse(response);
                                $(tableName).DataTable().ajax.reload(null, false);
                            },
                            error: fnToastrFormError,
                        });
                    },
                    text: lang.yes
                },
                Nej: {
                    text: lang.no
                }
            }
        });
    } else if(approvedByFirstApprover == 'false'){
        toastr.warning(langTwoStep.cannot_approve);
    }
    });


    $(document).off('click', btnReject);
    $(document).on('click', btnReject, function () {
        if($(this).data("first-approval")){
            var approvedByFirstApprover = $(this).data("first-approval").trim();
        };

        var approver = $(this).data("approver");
        var lang = allLangFiles.salary.pay_slips.two_step_approval;

        if(approvedByFirstApprover == true || approver == 'first-approver' || approver == 'no-two-step-approval-flow') {
            var rowData = JSON.parse($(tableName).DataTable().row($(this).parents('tr')).data().payslip);
            form.find('input[name=id]').attr('value', rowData.id);  
            if (approver == 'second-approver') {
                modal.modal('toggle');
            }
        } else {
            toastr.warning(lang.cannot_reject);
        };
    });

    
    form.off().on('submit', function (e) {
        //Init here as using 'this'. Changes inside function becasue of confirm.
        var action = this.action;
        var data = $(this).serialize();

        e.preventDefault();

        var lang = allLangFiles.salary.pay_slips.js.reject;

        $.confirm({
            title: lang.title,
            content: lang.content,
            theme: 'supervan',
            columnClass: 'col-md-12',
            backgroundDismiss: true,
            buttons: {
                Ja: {
                    action: function () {

                        e.preventDefault();

                        $.ajax({
                            type: 'POST',
                            data: data,
                            url: action,
                            success: function (response) {
                                printResponse(response);
                                console.log(response);
                                modal.modal('toggle');
                            },
                            error: fnToastrFormError,
                        });
                    },
                    text: lang.yes
                },
                Nej: {
                    text: lang.no
                }
            }
        });
    });  

    modal.off('hidden.bs.modal').on('hidden.bs.modal', function () {
        var excludeSubmitBtn = true;
        resetForm(form, excludeSubmitBtn);
        $(tableName).DataTable().ajax.reload(null, false);
    });
};
